var _defs, _g, _rect, _g2, _rect2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLightFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 291.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}.cls-4{fill:#eb008b;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0.69)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: -0.69,
    width: 600,
    height: 291.69
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "godoo_logo_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M484.42,80.23A26.45,26.45,0,1,1,458,53.88a26.4,26.4,0,0,1,26.45,26.35m25.27,0A51.71,51.71,0,1,0,458,131.77a51.62,51.62,0,0,0,51.71-51.54",
    transform: "translate(0 0.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M266.75,83A51.71,51.71,0,1,0,215,134.55,51.62,51.62,0,0,0,266.75,83",
    transform: "translate(0 0.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M574.73,80.23a26.45,26.45,0,1,1-26.45-26.35,26.4,26.4,0,0,1,26.45,26.35m25.27,0a51.71,51.71,0,1,0-51.71,51.54A51.62,51.62,0,0,0,600,80.23",
    transform: "translate(0 0.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128.81,130.39c5.54,10.14,5.09,16.27-3.39,26.3,11,3.64,9.36,2.79,13.7,4.49,3.85-4.34,20.22-20.65,1.57-42.63",
    transform: "translate(0 0.69)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 92.68,
    y: 19.92,
    width: 63.39,
    height: 24.49
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.91,220c0,25.73,27.21,46.59,60.77,46.59s60.78-20.86,60.78-46.59-27.21-46.59-60.78-46.59S31.91,194.22,31.91,220M0,220c0-39.24,41.49-71,92.68-71s92.68,31.81,92.68,71S143.87,291,92.68,291,0,259.19,0,220",
    transform: "translate(0 0.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.53,82.13A38.57,38.57,0,1,1,93,43.69a38.5,38.5,0,0,1,38.57,38.44m24.54,0A63.11,63.11,0,1,0,93,145a63,63,0,0,0,63.11-62.9",
    transform: "translate(0 0.69)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 375.04,
    width: 24.48,
    height: 82.79
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M375.07,82.11a38.43,38.43,0,1,1-38.43-38.43,38.43,38.43,0,0,1,38.43,38.43m24.45,0A62.88,62.88,0,1,0,336.65,145a62.88,62.88,0,0,0,62.88-62.88",
    transform: "translate(0 0.69)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLightFull);
export default __webpack_public_path__ + "static/media/logo-light-full.3f0374df.svg";
export { ForwardRef as ReactComponent };